// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".editor[data-v-49b6381b] {\n  width: 100%;\n  margin: 0 auto;\n  position: relative;\n  z-index: 0;\n}\n.toolbar[data-v-49b6381b] {\n  border: 1px solid #ccc;\n}\n.text[data-v-49b6381b] {\n  border: 1px solid #ccc;\n  border-top: none;\n  height: 400px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
